import store from '@/store'

// 缓存常常鲜微店信息
export function setCcxStore (storeData: any) {
  const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } = storeData
  // 去掉时间字符串中的秒
  const formatTime = (time: string) => time?.replace(/:00$/, '') || ''
  storeData = {
    ...storeData,
    pickupStartTime: formatTime(pickupStartTime),
    pickupEndTime: formatTime(pickupEndTime),
    takeStartTime: formatTime(takeStartTime),
    takeEndTime: formatTime(takeEndTime),
    openOnlineStore: storeData.openOnlineStore === 1 ? true : false
  }
  store.commit('SET_CCX_STORE', storeData)
}